var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8574 8.00003C14.8574 4.21293 11.7873 1.14288 8.00021 1.14288C4.21311 1.14288 1.14307 4.21293 1.14307 8.00003C1.14307 11.7871 4.21311 14.8572 8.00021 14.8572C11.7873 14.8572 14.8574 11.7871 14.8574 8.00003ZM13.9431 8.00003C13.9431 11.2822 11.2824 13.9429 8.00021 13.9429C4.71806 13.9429 2.05735 11.2822 2.05735 8.00003C2.05735 4.71788 4.71806 2.05717 8.00021 2.05717C11.2824 2.05717 13.9431 4.71788 13.9431 8.00003ZM7.54307 4.45717V5.25717C7.54307 5.50964 7.74774 5.71431 8.00021 5.71431C8.25268 5.71431 8.45735 5.50964 8.45735 5.25717V4.45717C8.45735 4.2047 8.25268 4.00003 8.00021 4.00003C7.74774 4.00003 7.54307 4.2047 7.54307 4.45717ZM7.54307 6.74288V11.5429C7.54307 11.7954 7.74774 12 8.00021 12C8.25268 12 8.45735 11.7954 8.45735 11.5429V6.74288C8.45735 6.49041 8.25268 6.28574 8.00021 6.28574C7.74774 6.28574 7.54307 6.49041 7.54307 6.74288Z",
    fill: "#1E5BC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.d2ad457b4b4930c20e7378539412128a.svg";
export { ForwardRef as ReactComponent };